import { combineReducers } from 'redux';
// Import reducers
import table from './activity_product_panel_reducer';

export default combineReducers({
	table
});
